<template>
  <div>
    <b-row>
      <b-col cols="12">
        <b-card class="mb-3" title="Yeni Kullanıcı Ekle">
          <!-- <b-alert variant="warning" show class="mb-0">
                        <div class="alert-body mb-2">
                           <span><strong>Not:</strong> Eklenecek podcast bağlantı linki
                                benzersiz olmalıdır...</span>
                        </div>
                    </b-alert> -->
          <b-button
            class="float-right"
            v-ripple.400="'rgba(255, 255, 255, 0.15)'"
            variant="primary"
            to="/users"
          >
            Kullanıcı Listesi
          </b-button>
        </b-card>
      </b-col>
    </b-row>
    <validation-observer ref="rules">
      <b-row>
        <b-col cols="12">
          <b-card class="mb-3" title="Kullanıcı Ekleme Formu">
            <b-row>
              <b-col cols="12">
                <b-form-group label="Ad Soyad" label-for="name">
                  <validation-provider
                    #default="{ errors }"
                    vid="name"
                    :rules="{ required: true }"
                    name="Ad Soyad"
                  >
                    <b-form-input
                      id="name"
                      type="text"
                      v-model="name"
                      placeholder="Ad Soyad"
                      :state="errors.length > 0 ? false : null"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col cols="12">
                <b-form-group label="E-Posta" label-for="email">
                  <validation-provider
                    #default="{ errors }"
                    vid="email"
                    :rules="{ required: true, email: true }"
                    name="E-Posta"
                  >
                    <b-form-input
                      id="email"
                      type="email"
                      v-model="email"
                      placeholder="E-Posta"
                      :state="errors.length > 0 ? false : null"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col md="12">
                <b-form-group label="Parola" label-for="password">
                  <validation-provider
                    #default="{ errors }"
                    vid="password"
                    :rules="{ required: true, min: 8, max: 16 }"
                    name="Parola"
                  >
                    <b-form-input
                      id="password"
                      type="password"
                      v-model="password"
                      placeholder="Parola"
                      :state="errors.length > 0 ? false : null"
                    />

                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col md="12">
                <b-form-group label="Parola Tekrarı" label-for="passwordConfirmation">
                  <validation-provider
                    #default="{ errors }"
                    vid="password"
                    :rules="{ required: true, min: 8, max: 16 }"
                    name="Parola Tekrarı"
                  >
                    <b-form-input
                      id="passwordConfirmation"
                      type="password"
                      v-model="passwordConfirmation"
                      placeholder="Parola Tekrarı"
                      :state="errors.length > 0 ? false : null"
                    />

                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col md="12" class="mt-5">
                <div>
                  <b-button
                    class="float-right mt-2"
                    v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                    variant="outline-success"
                    @click="postConfirmText(false, false)"
                  >
                    <b-spinner v-if="spinner === true" small />
                    {{ spinner === true ? "Kaydediliyor" : "Kaydet" }}
                  </b-button>
                </div>
              </b-col>
            </b-row>
          </b-card>
        </b-col>
      </b-row>
    </validation-observer>
  </div>
</template>
<script>
import DragDropImage from "../components/DragDropImage";
import vSelect from "vue-select";
import Ripple from "vue-ripple-directive";
import { heightTransition } from "@core/mixins/ui/transition";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import {
  BImg,
  BRow,
  BCol,
  BTime,
  BCard,
  BCardText,
  BButton,
  BForm,
  BMedia,
  BAlert,
  BSpinner,
  BFormInput,
  BFormGroup,
  BInputGroup,
  BFormTextarea,
  BMediaAside,
  BMediaBody,
  BFormFile,
  BFormDatepicker,
  BFormCheckbox,
  BLink,
} from "bootstrap-vue";
import {
  required,
  email,
  confirmed,
  url,
  between,
  alpha,
  integer,
  password,
  min,
  digits,
  alphaDash,
  length,
} from "@validations";

import settings from "../../../settings";
import { Endpoints } from "@core/endpoints/endpoints";
const endpoints = new Endpoints();

export default {
  components: {
    DragDropImage,
    BImg,
    BRow,
    BCol,
    BTime,
    BLink,
    BCard,
    BCardText,
    BButton,
    BForm,
    BSpinner,
    BAlert,
    BFormGroup,
    BFormInput,
    BInputGroup,
    BFormTextarea,
    BMedia,
    BMediaAside,
    BMediaBody,
    BFormFile,
    BFormDatepicker,
    BFormCheckbox,
    vSelect,
    ValidationProvider,
    ValidationObserver,
    required,
    email,
    confirmed,
    url,
    between,
    alpha,
    integer,
    password,
    min,
    digits,
    alphaDash,
    length,
  },
  directives: {
    Ripple,
  },
  mixins: [heightTransition],
  data() {
    return {
      name: "",
      email: "",
      password: "",
      passwordConfirmation: "",
      spinner: false,
    };
  },
  watch: {},
  methods: {
    postConfirmText() {
      this.$swal({
        title: "Kayıt?",
        text: "Yeni kullanıcıyı kaydetmek istediğinize emin misiniz?",
        icon: "warning",
        showCancelButton: true,
        cancelButtonText: "Vazgeç!",
        confirmButtonText: "Kaydet!",
        customClass: {
          confirmButton: "btn btn-primary",
          cancelButton: "btn btn-outline-danger ml-1",
        },
        buttonsStyling: false,
      }).then((result) => {
        if (result.value) {
          this.postSubmit();
        }
      });
    },
    postSubmit() {
      this.$refs.rules.validate().then((success) => {
        if (success) {
          this.spinner = true;
          let formData = new FormData();
          formData.append("name", this.name);
          formData.append("email", this.email);
          formData.append("password", this.password);
          formData.append("password_confirmation", this.passwordConfirmation);
          endpoints
            .postUsers(formData, this.$i18n.locale, () => {})
            .then((data) => {
              this.spinner = false;

              if (!data.status) {
                this.$swal({
                  icon: "error",
                  title: "Hata!",
                  text: "Kullanıcı zaten kayıtlı.",
                  customClass: {
                    confirmButton: "btn btn-primary",
                  },
                }).then((result) => {});
              } else {
                this.$swal({
                  icon: "success",
                  title: "Kayıt başarılı!",
                  text: "Yeni kullanıcı eklendi.",
                  customClass: {
                    confirmButton: "btn btn-success",
                  },
                }).then((result) => {
                  if (result.value) {
                    this.$router.push({
                      path: `/users`,
                    });
                  }
                });
              }
            })
            .catch((err) => {
              this.spinner = false;
              console.log(err);
            });
        }
      });
    },
  },
  created() {},
  destroyed() {},
  mounted() {},
  setup() {},
};
</script>

<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
</style>
